<template>
  <div>
    <div class="chart-mode-choose" v-if="chartkey==='service'">
      <div v-for="(item,index) in tagData" :key="index" :class="{'mode-tag': true, 'mode-selected': index === currentMode}" @click="chooseMode(index)">
        <p>{{item.name}}</p>
      </div>
    </div>
    <div class="chart-canvas-container">
       <div class="chart-canvas" :style="{ height: height+'PX'}" ref="wrap"></div>
       <div class="chart-canvas-btn"  @click="showHor" :style="{ bottom: chartOptions.grid.bottom+'PX', right: chartOptions.grid.right+'PX'}" @click.stop="showHor(chartkey)" v-if="direction==='vertical'">
         <i class="crm-quanping"></i>
       </div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import EventBus from './../../utils/eventBus'

export default {
  props: {
    options: [],
    height: {},
    chartkey: {
      type: String,
      default: ''
    },
    direction: {
      type: String,
      default: 'vertical'
    }
  },
  data() {
    return {
      currentMode: 0,
      tagData: [{
        name: this.$t('Gattaran_opt_QCLu_UWmJ'/** 取消订单 */),
      }, {
        name: this.$t('Gattaran_opt_cWad_xQOF'/** 问题订单 */),
      }],
    }
  },
  watch: {
    options (nVal, oVal) {
      if (nVal !== oVal) {
        this.currentMode = 0
        if (this.direction === 'vertical') {
          this.init()
        } else {
          this.Horinit()
        }
      }
    }
  },
  computed: {
    chartOptions() {
      return this.options[this.currentMode]
    }

  },
  mounted () {
    this.currentMode = 0
    if (this.direction === 'vertical') {
      this.init()
    } else {
      this.Horinit()
    }
    // 接受到点击了其他区域的消息，隐藏图表的tooltip
    EventBus.$on('handleToolTipClose', message => {
      this.charts.dispatchAction({
        type: 'hideTip'
      })
    })
  },
  methods: {
    showHor(chartKey) {
      this.$emit('showHorCharts', chartKey)
    },
    chooseMode(index) {
      if (this.currentMode !== index) {
        this.currentMode = index
        this.init()
      }
    },
    Horinit() {
      setTimeout(() => {
        if (!this.charts) {
          this.charts = echarts.init(this.$refs.wrap)
        }
        if (this.chartOptions) {
          // 必须clear, 否则图表切换tooltip展示有问题
          this.charts.clear()
          this.charts.setOption(this.chartOptions)
          this.charts.resize()
        }
      }, 0)
    },
    init () {
      if (!this.charts) {
        this.charts = echarts.init(this.$refs.wrap)
      }
      if (this.chartOptions) {
        this.charts.setOption(this.chartOptions)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.chart-canvas {
  position: relative;
  margin-top: 32px;
  margin-bottom: 12PX;
}
.chart-canvas-container{
  position: relative;
  .crm-quanping{
    width: 18px;
    height: 18px;
    font-size: 18px;
    color: #FFFFFF;
  }
  .chart-canvas-btn{
    position: absolute;
    width: 40px;
    height: 40px;
    opacity: 0.6;
    background: #000000;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

}
.chart-mode-choose{
  display: flex;
  margin-top: 40px;
  .mode-tag{
    height: 32px;
    background: #F0F1F5;
    border-radius: 12px;
    padding: 8px 16px;
    margin-right: 24px;
    font-size: 24px;
    p{
      line-height: 32px;
      color: #595C66;
    }
  }
  .mode-selected{
    background: #FFEFE7;
    p{
      color: #F76A31;
    }
  }
}
</style>
